import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { getNoVehicleImageToDisplay } from 'site-modules/shared/utils/get-no-vehicle-image-to-display';

export class CardImage extends PureComponent {
  static propTypes = {
    photoUrl: PropTypes.string,
    altText: PropTypes.string,
    bodyType: PropTypes.string,
    className: PropTypes.string,
    lazy: PropTypes.bool,
  };

  static defaultProps = {
    photoUrl: '',
    altText: 'vehicle',
    bodyType: '',
    className: '',
    lazy: false,
  };

  state = { loadError: false };

  onError = () => {
    this.setState({ loadError: true });
  };

  render() {
    const { photoUrl, altText, bodyType, className, lazy } = this.props;
    if (!photoUrl) return null;
    const { loadError } = this.state;
    const defaultPhoto = getNoVehicleImageToDisplay(bodyType);

    return (
      <img
        alt={altText}
        src={loadError ? defaultPhoto : photoUrl}
        onError={this.onError}
        className={className}
        loading={lazy ? 'lazy' : null}
      />
    );
  }
}
